<template>
  <a-modal
    title="进场主材"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="主材名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['name', {rules: [{required: true, message: '请输入主材名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="规格"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['format', {rules: [{required: true, message: '请输入规格'}]}]" />
        </a-form-item>
        <a-form-item
          label="数量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入数量"
            v-decorator="['number', {rules: [{required: true, message: '请输入数量'}]}]" />
        </a-form-item>
        <a-form-item
          label="单位"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['unit', {rules: [{required: true, message: '请输入单位'}]}]" />
        </a-form-item>
        <a-form-item
          label="单号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['orderNumber', {rules: [{required: true, message: '请输入单号'}]}]" />
        </a-form-item>
<!--        <a-form-item-->
<!--          label="运费"-->
<!--          :labelCol="labelCol"-->
<!--          :wrapperCol="wrapperCol"-->
<!--        >-->
<!--          <a-input-number-->
<!--            :precision="2"-->
<!--            style="width: 100%"-->
<!--            :min="0"-->
<!--            :disabled="showable"-->
<!--            placeholder="请输入运费(精确到分)"-->
<!--            v-decorator="['freight', {rules: [{required: true, message: '请输入运费(精确到分)'}]}]" />-->
<!--        </a-form-item>-->
        <a-form-item
          label="预付款"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入预付款(精确到分)"
            v-decorator="['advancePay', {rules: [{required: true, message: '请输入预付款(精确到分)'}]}]" />
        </a-form-item>
        <a-form-item
          label="采购人"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            showSearch
            :disabled="showable"
            placeholder="请选择"
            v-decorator="['purchaserId', {rules: [{required: true, message: '请选择采购人'}]}]"
            :options="purchaserList"
            optionFilterProp="children"
          >
          </a-select>
        </a-form-item>
        <a-form-item
          label="备注(供货商及其他信息)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark']"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { dropDownByCode } from '@/api/sys/user'
export default {
  name: 'DailyMaterialAdd',
  components: {},
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      purchaserList: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false,
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      }
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      dropDownByCode(this.purchaserQuery).then(res => {
        this.purchaserList = res.data
      })
      if (type === 'edit') {
        this.type = type
        this.theKey = child.key
      }
      if (type && type === 'add') {
        this.type = type
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'name',
          'format',
          'number',
          'unit',
          'orderNumber',
          'freight',
          'advancePay',
          'remark',
          'purchaserId'
        ]
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 结束保存用户信息
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
          }
          this.visible = false
        }
      })
    },
    handleCancel () {
      this.visible = false
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    }
  }
}
</script>

<style scoped>

</style>
